import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
//import VueLodash from "vue-lodash";
import VTooltip from "v-tooltip";
import { /*Grid,*/ GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import AsyncComputed from "vue-async-computed";
import plugInTranslations from "./plugins/pluginTranslations.js";

import "@progress/kendo-ui";
import "@progress/kendo-theme-bootstrap/dist/all.css";

import "../scss/style.scss";
import "element-ui/lib/theme-chalk/index.css";

//import JsonCSV from "vue-json-csv";
//Vue.component("downloadCsv", JsonCSV);

import Chartkick from "vue-chartkick";
import Chart from "chart.js";

//import JsonExcel from "vue-json-excel";
//Vue.component("downloadExcel", JsonExcel);

Vue.use(Chartkick.use(Chart));

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

//Vue.use(VueLodash);
Vue.use(GridInstaller);

Vue.use(AsyncComputed);

Vue.use(plugInTranslations);

const defaultLanguage = "en-US";

import { getLoadedLanguages } from "./i18n";
import { getMessages } from "./i18n";

function translationsLoaded() {
  var loadedLanguages = getLoadedLanguages();
  var nrMessages = getMessages().length;
  if (loadedLanguages.includes("en-US") && nrMessages > 0) {
    return true;
  }
  return false;
}

Vue.use(VTooltip);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  store,
  render: h => h(App)
});

if (!String.format) {
  String.format = function(format) {
    const args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, (match, number) =>
      typeof args[number] !== "undefined" ? args[number] : match
    );
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}
